import pie from './pie';
import bar from './bar';
import line from './line';

export { pie, bar, line };
export default { pie, bar, line };
